import { formattedTokenCost } from 'utils/common';
import { ASSET_PREFIX } from 'utils/constants';
import styles from './PurchaseTokensBanner.module.css';

interface PurchaseTokensBannerProps {
  tokenCount: number;
  onClick: () => void;
}

const PurchaseTokensBanner = ({ tokenCount, onClick }: PurchaseTokensBannerProps) => {
  return (
    <section className={styles.purchaseTokensBannerContainer}>
      <img
        className={styles.icon}
        src={`${ASSET_PREFIX}/images/token-town/arcade-gold-token.svg`}
        alt=""
      />
      <p className={styles.purchaseTokensBannerText}>
        You have {formattedTokenCost(tokenCount)} <br />
        <strong
          onClick={() => onClick()}
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          Purchase more
        </strong>
      </p>
      <img
        className={styles.icon}
        src={`${ASSET_PREFIX}/images/token-town/arcade-gold-token.svg`}
        alt=""
      />
    </section>
  );
};

export default PurchaseTokensBanner;
